import { FC } from 'react';

export const TOOLTIP_NAMESPACE: string = 'tooltip';

export interface ITooltipRef {
    topBound: number | undefined;
    leftBound: number | undefined;
    offsetHeight: number | undefined;
}

export interface ITooltipMessage {
    messageComponent: FC | null;
    ref: ITooltipRef | null;
}

export interface ITooltipState {
    message: ITooltipMessage | null;
}
